// extracted by mini-css-extract-plugin
module.exports = {"wrap":"NineImg__wrap___1dK8Q","cell":"NineImg__cell___3je33"};